var link_preview_default = {
  "fontElementMap": "I0FfS",
  "linkPreviewContainer": "R3hNk",
  "linkPreview": "GBf32",
  "linkPreviewImage": "cR6JA",
  "linkPreviewPlaceholder": "Sk9P9",
  "linkPreviewInfo": "jygW2",
  "linkPreviewTitle": "KGdzD",
  "linkPreviewDescription": "B8LhG",
  "linkPreviewUrl": "ktEqw",
  "linkPreviewResponsiveImage": "neTAx",
  "loadingContainer": "vSv3Z",
  "errorIcon": "h0Y6f",
  "errorInfo": "w04mr",
  "errorContainer": "_9ZvHC",
  "overlay": "XzIMG",
  "thumbnailEnd": "x9prd",
  "thumbnailStart": "fi-fR",
  "thumbnailTop": "_7RF1s"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
